import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('../views/Home.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/mobileAbout',
    component: () => import('../views/mobile/MobileAbout.vue')
  },
  {
    path: '/search',
    component: () => import('../views/Search.vue'),
  },
  {
    path: '/searchDetail',
    component: () => import('../views/search/searchDetail.vue')
  },
  {
    path: '/hui',
    component: () => import('../views/Hui.vue')
  },
  {
    path: '/customer',
    component: () => import('../views/Customer.vue')
  },
  {
    path: '/contact',
    component: () => import('../views/Contact.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
